import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';

export const useTranslate = () => {
    const language = useSelector((state: ApplicationState) => state.translation.language);

    return (translations: string[]) => translations[language];
};
